import { useAuth as useClerkAuth } from '@clerk/clerk-react';

export const clerkPublishableKey =
  process.env.REACT_APP_CLERK_PUBLISHABLE_KEY ||
  process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY || '';

const allowClerkInDev =
  process.env.REACT_APP_ENABLE_CLERK_IN_DEV === 'true' ||
  process.env.NEXT_PUBLIC_ENABLE_CLERK_IN_DEV === 'true';

// Enable Clerk when a key is present in production, or explicitly allowed in dev.
export const isClerkEnabled =
  Boolean(clerkPublishableKey) &&
  (process.env.NODE_ENV === 'production' || allowClerkInDev);

// Custom hook that safely exposes Clerk auth state. When Clerk is disabled
// (e.g., in development), it returns no-op defaults so the app can run.
function useAuthDisabled() {
  return {
    isLoaded: true,
    isSignedIn: false,
    getToken: async () => null,
  };
}

function useAuthEnabled() {
  return useClerkAuth();
}

export const useAuthCompat = isClerkEnabled ? useAuthEnabled : useAuthDisabled;
